import { render } from "./units-tab.vue?vue&type=template&id=557b6736&scoped=true"
import script from "./units-tab.vue?vue&type=script&lang=js"
export * from "./units-tab.vue?vue&type=script&lang=js"

import "./units-tab.vue?vue&type=style&index=0&id=557b6736&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557b6736"]])

export default __exports__